module.exports = __webpack_public_path__ + "media/paliwa/other-75fde296.png";